import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Card,
    Stack,
    Type,
} from 'react-spark';
import { OffersV3TermSelector } from './OffersV3TermSelector';
import { OffersV3OfferDetails } from './OffersV3OfferDetails';
import URCButton from '../../button/Button';
import stateSelectors from '../../redux/state-selectors';
import offerStateSelectors from '../../redux/offer/state-selectors';
import actionCreator from '../../redux/offer/action-creator';
import actionCreatorOffers from '../../redux/action-creator';

import { FONT_SIZES } from '../../../../utils/novaTypography';

export class OffersV3SingleOfferTermComponent extends Component {
    static propTypes = {
        selectedAmount: PropTypes.number,
        offersForAmount: PropTypes.array,
        hasMultipleTerms: PropTypes.bool,
        selectedTerm: PropTypes.number,
        onSelectOffer: PropTypes.func,
        selectOffer: PropTypes.func,
        onTermSelect: PropTypes.func,
        hasQlDiscount: PropTypes.bool.isRequired,
        getsRLReturningClientDiscount: PropTypes.bool.isRequired,
        isTeamMember: PropTypes.bool.isRequired,
        maxOffer: PropTypes.number.isRequired,
        isSelectingOffer: PropTypes.bool.isRequired,
        autoPayDiscountConfig: PropTypes.object,
    };

    static defaultProps = {
        maxOffer: 0,
        hasQlDiscount: false,
        getsRLReturningClientDiscount: false,
        isTeamMember: false,
        selectedAmount: 0,
        offersForAmount: [],
        hasMultipleTerms: false,
        selectedTerm: null,
        onSelectOffer: () => { },
        onTermSelect: () => { },
    };


    render() {
        const { 
            selectOffer, 
            hasMultipleTerms, 
            offersForAmount, 
            selectedTerm, 
            isSelectingOffer,
            onTermSelect,
            hasQlDiscount,
            getsRLReturningClientDiscount,
            isTeamMember,
            autoPayDiscountConfig,
        } = this.props;

        // Find the offer for the selected term, or use the first available offer
        let selectedOffer = offersForAmount[0];
        if (hasMultipleTerms && selectedTerm) {
            selectedOffer = offersForAmount.find(offer => offer.duration === selectedTerm) || offersForAmount[0];
        }

        return (
            <div>
                <Card className="offers-v3-card sprk-u-mbl">
                    <Card.Content>
                        <Stack>
                            { hasMultipleTerms && (
                                <Stack.Item className="sprk-u-PaddingBottom--a">
                                    <OffersV3TermSelector
                                        hasMultipleTerms={hasMultipleTerms}
                                        offersForAmount={offersForAmount}
                                        selectedTerm={selectedTerm}
                                        onTermSelect={onTermSelect}
                                    />
                                </Stack.Item>
                            )}
                            <Stack.Item>
                                <OffersV3OfferDetails
                                    selectedOffer={selectedOffer}
                                    hasQlDiscount={hasQlDiscount}
                                    getsRLReturningClientDiscount={getsRLReturningClientDiscount}
                                    isTeamMember={isTeamMember}
                                    hasMultipleTerms={hasMultipleTerms}
                                    autoPayDiscountConfig={autoPayDiscountConfig}
                                />
                            </Stack.Item>
                        </Stack>
                    </Card.Content>
                </Card>

                <div>
                    <URCButton
                        id="select-offer"
                        name="selectOffer"
                        variant='primary'
                        loading={isSelectingOffer}
                        onClick={() => selectOffer(selectedOffer.id)}
                        className='button-nova'
                    >
                        Select offer
                    </URCButton>

                    <div style={{ marginTop: '8px', textAlign: 'center' }}>
                        <Type.BodyFour className='sprk-u-man' style={{ fontSize: FONT_SIZES.disclaimer, color: '#545454'  }}>
                            Selecting an offer isn't a commitment to a loan.
                        </Type.BodyFour>
                    </div>
                </div>
            </div>
        );
    }
}

// Redux connection
const mapStateToProps = (state, props) => {
    const selectedAmount = props.selectedAmount || props.customizedOffer || props.maxOffer;
    const offersForAmount = stateSelectors.selectOffersForAmount(state, {
        amount: selectedAmount
    });
    const selectedTerm = stateSelectors.selectSelectedTermForAmount(state, {
        amount: selectedAmount
    });
    const isSelectingOffer = offerStateSelectors.getOfferSelecting(state);

    return {
        ...props,
        selectedAmount,
        offersForAmount,
        hasMultipleTerms: offersForAmount.length > 1,
        selectedTerm,
        isSelectingOffer: isSelectingOffer ? true : false,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const selectedAmount = props.selectedAmount || props.customizedOffer || props.maxOffer;

    return {
        onTermSelect: (term) => dispatch(actionCreatorOffers.selectOfferTerm(selectedAmount, term)),
        selectOffer: (offerId) => dispatch((_, getState) => {
            const state = getState();
            if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
                dispatch(actionCreator.selectOfferAuthenticated(offerId, state.loan.loanJson.loanId));
            } else {
                dispatch(actionCreator.selectOffer(offerId));
            }
        }),
    };
};

export const OffersV3SingleOfferTerm = connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersV3SingleOfferTermComponent);
